
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M2 12C2 6.486 6.486 2 12 2s10 4.486 10 10-4.486 10-10 10S2 17.514 2 12zm1.311 0c0 4.79 3.898 8.689 8.689 8.689 4.79 0 8.688-3.898 8.688-8.689 0-4.79-3.897-8.688-8.688-8.688S3.31 7.209 3.31 12z"}}),_c('path',{attrs:{"d":"M15.62 8.726l-5.156 5.157-2.085-2.084a.656.656 0 00-.927.927L10 15.274a.654.654 0 00.928 0l.001-.002 5.618-5.618a.655.655 0 10-.927-.928z"}})])
          )
        }
      }
    